import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import it from "./locales/it.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import ar from "./locales/ar.json";

export const SUPPORTED_LANGUAGES = [
  { code: "it", name: "Italiano", flag: "🇮🇹" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "ar", name: "العربية", flag: "🇦🇪" },
];

export const RTL_LANGUAGES = ["ar"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      de: { translation: de },
      ar: { translation: ar },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    detection: {
      // La lingua è guidata dal prefisso URL (LanguageRouter). localStorage
      // contiene solo la scelta esplicita dell'utente (arabell_lang_pref).
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "arabell_lang_pref",
      caches: [],
    },
    interpolation: { escapeValue: false },
  });

// Apply RTL direction + lang attribute on <html> when language changes
const applyDirAndLang = (lng) => {
  if (!lng) return;
  const code = lng.split("-")[0];
  const html = document.documentElement;
  html.lang = code;
  html.dir = RTL_LANGUAGES.includes(code) ? "rtl" : "ltr";
};
// Apply once init resolves and then on every change
i18n.on("initialized", () => applyDirAndLang(i18n.resolvedLanguage || i18n.language));
i18n.on("languageChanged", applyDirAndLang);
// Also apply immediately in case init was already finished
applyDirAndLang(i18n.resolvedLanguage || i18n.language);

export default i18n;
